"use strict";
import "lodash";
import { svc_addOne, svc_fetchOne, svc_editOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

const endpointBasePrefix = "mall-upload/file";

const Model = {
	namespace: "m_MallUploadFile",
	state: {
		uploadFile: {},
		uploadFiles: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { uploadFiles } }) {
			return { ...state, uploadFiles };
		},
		handleFetchOne(state, { payload }) {
			return { ...state, uploadFile: payload };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			const uploadFiles = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(uploadFiles.result, function (row) {
				row.key = row.id;
				row.upload_date = convertISODateTimeToString(row.upload_date, null, config.dateTimeFormat);
				row.created_at = convertISODateTimeToString(row.created_at, null, config.dateTimeFormat);

				// setting the button
				if (row.status === "FAILED_TO_UPLOAD" || row.status === "READY_TO_UPLOAD") {
					row.hideCancelledBtn = false;
				} else {
					row.hideCancelledBtn = true;
				}
			});

			yield put({
				type: "handleFetchAll",
				payload: { uploadFiles },
			});
		},

		// post / repost of upload file 
		*postFile({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/post`, payload);
			showServerResponse(response);
			return response;
		},

		// cancellation of single upload file
		*void({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/cancel`, payload);
			showServerResponse(response);
			return response;
		},

		// regenerate single upload file
		*regenerate({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/regenerate`, payload);
			showServerResponse(response);
			return response;
		},

		// return latest mall upload file from specific config id
		*fetchOneConfig({ searchKey, payload }, { call, put }) {
			if (!searchKey && payload) {
				searchKey = payload;
			}
			const response = yield call(svc_fetchOne, `${endpointBasePrefix}/latest`, searchKey);
			showServerResponse(invoice, true);

			let invoice;
			if (response.result && response.result.length == 1) {
				invoice = response.result[0];
			}

			return invoice;
		},
	},
	subscriptions: {},
};

export default Model;
